import { useEffect } from 'react';
import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

// import { useTheSupportersSunriseContext } from '../../../../shared/context';
import { useTheSupportersContext } from '../../../../shared/context';
import { useSignaturesDistributionContext } from '../../shared/provider';
import { Loaders } from '../Loaders';
import { SignatureMapConfigurator } from '../SignatureMapConfigurator';
import { useSignaturesDistributionHidden } from '../SignaturesDistributionHidden';
import { SignaturesDistributionInfo } from '../SignaturesDistributionInfo';

import { useClusterPercentage } from './hooks/useClusterPercentage';
import { useFetchSignaturesDistribution } from './hooks/useFetchSignaturesDistribution';
import { useSignaturesDistribution } from './hooks/useSignaturesDistribution';
import { useZoomLevel } from './hooks/useZoomLevel';

type Props = {
	isStaff: boolean;
};

export const SignaturesDistribution: React.FC<Props> = ({ isStaff }) => {
	const {
		data: { hasMap },
		actions: { setHasMap },
	} = useTheSupportersContext();
	const {
		data: { hasNoCluster, isNotInSignatureCountRange, noData },
	} = useSignaturesDistributionContext();

	useFetchSignaturesDistribution();
	useSignaturesDistribution(isStaff);
	useZoomLevel();
	useClusterPercentage();
	useSignaturesDistributionHidden({
		noClusterFound: hasNoCluster,
		countNotInRange: isNotInSignatureCountRange,
	});

	useEffect(() => {
		if (hasNoCluster && hasMap) {
			setHasMap(false);
		}
	}, [hasNoCluster, setHasMap, hasMap]);

	if (hasNoCluster || isNotInSignatureCountRange || noData) {
		return null;
	}

	return (
		<div data-qa="supporter-map-container" data-testid="supporter-map-container" className="flex flex-col">
			<Text as="h1" fontWeight="bold" size="large" variant="heading" className="mb-12">
				<Translate value="corgi.petition_gamma.signature_map.title" />
			</Text>
			<Loaders />
			<SignaturesDistributionInfo isStaff={isStaff} />
			{isStaff && <SignatureMapConfigurator />}
		</div>
	);
};
